import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { CommonConfig } from '../../configs/config.common';

@Component
export default class EpicGraphicTextSection extends Vue {
    @Prop({ default: function() {
        const configs = new CommonConfig();
        return  [{
            icon: `${configs.rifoDesignAssetsUrl}/epic-home-loan/step1.png`,
            title: 'Contact A Finance Agent',
            paragraph: 'First, tell our finance agent the requirement for home you want to buy or rent.'
        }, {
            icon: `${configs.rifoDesignAssetsUrl}/epic-home-loan/step2.png`,
            title: 'Talk to A Local Lender',
            paragraph: 'Second, we help you to find the best suitable local lender, who can be more easier to get accessed.'
        }, {
            icon: `${configs.rifoDesignAssetsUrl}/epic-home-loan/step3.png`,
            title: 'Meet A Finance Lawyer',
            paragraph: 'Finally,  our real estate lawyer will secure the home buying or renting process.'
        }];
    } })
    public stepList!: any;

    @Prop({ default: function() {
        const configs = new CommonConfig();
        return `${configs.rifoDesignAssetsUrl}/epic-home-loan/graphic.png`;
    } })
    public graphic!: string;
    @Prop({ default: false })
    public reverse!: boolean;

    @Prop({ default: true })
    public showNo!: boolean;
    @Prop({ default: '' })
    public title!: string;

    @Prop({ default: '#FFFFFF' })
    public bgColor!: string;
}
